import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Container,
  Button,
} from "reactstrap";

// core components

function SectionIntroduction() {

  return (
    <>
      <div className="cd-section" id="portfolio">
        <div
          className="page-header"
          // ref={pageHeader}
          style={{
            backgroundImage:
              "url(" + require("assets/img/event.jpg") + ")",
          }}
        >
          <div className="filter" />
          <div className="content-center">
            <Container>
              <div className="motto">
                <h2 className="description">
                  <b>
                    Delievering solutions exceeding your expectations
                </b>
                </h2>
                <br />
                <Button
                  className="btn-round mr-1"
                  color="neutral"
                  href="https://www.youtube.com/watch?v=dQw4w9WgXcQ?ref=creativetim"
                  target="_blank"
                >
                  <i className="fa fa-play" />
                Who are we ?
              </Button>
                <Button
                  className="btn-round"
                  color="neutral"
                  type="button"
                  to="/portfolio"
                  tag={Link}
                  outline
                >
                  Portfolio
                      </Button>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionIntroduction;
